import { render, staticRenderFns } from "./EventScrollContainer.vue?vue&type=template&id=4c5e5d3f"
import script from "./EventScrollContainer.vue?vue&type=script&lang=js"
export * from "./EventScrollContainer.vue?vue&type=script&lang=js"
import style0 from "./EventScrollContainer.vue?vue&type=style&index=0&id=4c5e5d3f&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports